import { render } from "./Scor.vue?vue&type=template&id=8d9475e2"
import script from "./Scor.vue?vue&type=script&lang=js"
export * from "./Scor.vue?vue&type=script&lang=js"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__